/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/googleVisibility API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    topActionPriorities (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/progression-axis/top-action-priorities`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readBlockType (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/progression-axis/block-type`,filters)
    },
    /**
     * @param projectId int
     * @returns Promise
     */
    readBlockOccurrenceFrequency (projectId) {
        return axios.get(`/report/data/projects/${projectId}/google-visibility/block-occurrence-frequency`)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readBlockPerformance (projectId) {
        return axios.get(`/report/data/projects/${projectId}/google-visibility/block-performance`)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readImprovementWay (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/progression-axis/improvement-way`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readPositionList (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/progression-axis/position-list`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readImprovementPotentialKeywords (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/progression-axis/improvement-potential-keywords`,filters)
    },

};
